import styled from '@emotion/styled'

export const GridEvents = styled.div`
  display: grid;
  gap: 20px;
  margin-top: 50px;
  grid-template-columns: ${({ gridConfig }) => `repeat(${gridConfig}, 1fr)`};
`
